import type { Action } from './actions'
import type {
    BirthdayFormData,
    MetaShortDTO,
    RestaurantShortDTO
} from 'shared/types'
import endpoints from 'shared/store/endpoints'
import { managePageAPIError } from 'shared/store/utils'

export type State = {
    metaData: ?MetaShortDTO,
    formData?: BirthdayFormData,
    restaurants: Array<RestaurantShortDTO>,
    selectedRestaurant: ?RestaurantShortDTO,
    success?: boolean,
    sendFormError?: any,
    dataLoaded?: boolean,
    error?: any,
    networkError?: any
}

const initialState: State = {
    metaData: null,
    restaurants: [],
    selectedRestaurant: null
}

export const reducer = (state: State = initialState, action: Action): State => {
    switch (action.type) {
        case 'BIRTHDAY_PAGE_RESPONSE':
            return {
                ...state,
                ...action.data,
                dataLoaded: true,
                error: undefined,
                networkError: undefined
            }
        case 'SEARCH_RESULTS':
            return {
                ...state,
                restaurants: action.restaurants
            }
        case 'CLEAR_SEARCH':
            return {
                ...state,
                restaurants: [],
                selectedRestaurant: null
            }
        case 'BIRTHDAY_SELECT_RESTAURANT':
            return {
                ...state,
                selectedRestaurant: action.selectedRestaurant
            }
        case 'BIRTHDAY_SEND_FORM_SUCCESS':
            return {
                ...state,
                success: true,
                sendFormError: undefined
            }
        case 'BIRTHDAY_SEND_FORM_ERROR':
            return {
                ...state,
                sendFormError: action.sendFormError
            }
        case 'BIRTHDAY_ERROR':
            return {
                ...state,
                error: action.error
            }
        case 'BIRTHDAY_RESET_SUCCESS':
            return {
                ...state,
                success: undefined,
                error: undefined,
                selectedRestaurant: null
            }
        case 'PAGE_API_ERROR':
            return managePageAPIError(
                state,
                action,
                endpoints.pages.birthday.page
            )
        case 'RESET_NETWORK_ERROR':
            return {
                ...state,
                networkError: undefined
            }
        case 'PAGE_NETWORK_ERROR':
            return {
                ...state,
                networkError: action.networkError,
                error: undefined
            }
        default:
            return state
    }
}
